import React, { PureComponent } from 'react';
import QuestionBalloon from './Balloon/QuestionBalloon';
import BotMessages from './BotMessages';
import Loading from './Balloon/LoadingBalloon'

class ChatMessageList extends PureComponent {

    componentDidUpdate(prevProps, prevState) {
        // THIS PART HANDLES AUTO SCROLLING AFTER DATA FETCHING
        if(prevProps.data.data.length !== this.props.data.data.length) {
            //this.scrollToBottom();
            this.element.scrollTop = this.element.scrollHeight - (this.botElement.scrollHeight + 85);
        }
    }

    render() {
        //const toggleLoding = this.props.message.isLoading
        //console.info(this.props)

        return (
            <div className="chat_container" ref={(ref)=>{this.element = ref}} onScroll={this.handleScroll} onClick={()=> {this.props.toggleRealtimeAnswer(true)}}>
            <div className="chat_content">
            <div className="bubble_wrap">
                { this.props.data.data.map(
                    (message, idx) => (
                        message.outputs 
                        ? message.quickReplies 
                            ? <div className="bubble_area" key={idx} ref={(bot)=>{this.botElement = bot}}>
                                <BotMessages data={ message.outputs } isGreeting={this.props.data.isGreeting} quickBtns={message.quickReplies} 
                                            isDev={this.props.isDev} fromApp={this.props.fromApp} uiTexts={this.props.uiTexts}/>
                              </div>
                            : <div className="bubble_area" key={idx} ref={(bot)=>{this.botElement = bot}}>
                                <BotMessages data={ message.outputs } isGreeting={this.props.data.isGreeting}  isDev={this.props.isDev}
                                            fromApp={this.props.fromApp} uiTexts={this.props.uiTexts}/>
                              </div>
                        : message.input &&
                            <QuestionBalloon key={idx} data={ message.input } favorite={this.props.favorite}/>
                    )
                )
                }
                { this.props.data.isLoading && <Loading/> }
            </div>
            </div>
            </div>
        );
    }
};


export default ChatMessageList;